import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function EditShipment() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Dummy data for demonstration
  const dummyShipmentData = {
    trackingNumber: 'TRK001',
    senderName: 'John Doe',
    receiverName: 'Jane Smith',
    origin: 'Los Angeles',
    destination: 'New York',
    currentLocation: 'Chicago',
    status: 'In Transit',
    timeline: [
      { location: 'Los Angeles', status: 'Shipped', timestamp: '2023-01-01 10:00 AM' },
      { location: 'Chicago', status: 'In Transit', timestamp: '2023-01-03 02:30 PM' }
    ],
    dateShipped: '2023-01-01',
    estimatedDelivery: '2023-01-05'
  };

  const [formData, setFormData] = useState(dummyShipmentData);

  useEffect(() => {
    // Fetch shipment data based on id
    // For now, using dummy data
    setFormData(dummyShipmentData);
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleTimelineChange = (index, field, value) => {
    const newTimeline = [...formData.timeline];
    newTimeline[index][field] = value;
    setFormData(prevState => ({
      ...prevState,
      timeline: newTimeline
    }));
  };

  const addTimelineEntry = () => {
    setFormData(prevState => ({
      ...prevState,
      timeline: [...prevState.timeline, { location: '', status: '', timestamp: '' }]
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Updated shipment data:', formData);
    // Dummy submit handler
    alert('Shipment updated successfully!');
    navigate('/admin/dashboard');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <h1 className="text-3xl font-bold mb-4">Edit Shipment</h1>
      <div className="bg-white p-6 rounded shadow-md w-full max-w-2xl">
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700">Tracking Number</label>
            <input
              type="text"
              name="trackingNumber"
              value={formData.trackingNumber}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Sender Name</label>
            <input
              type="text"
              name="senderName"
              value={formData.senderName}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Receiver Name</label>
            <input
              type="text"
              name="receiverName"
              value={formData.receiverName}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Origin</label>
            <input
              type="text"
              name="origin"
              value={formData.origin}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Destination</label>
            <input
              type="text"
              name="destination"
              value={formData.destination}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Current Location</label>
            <input
              type="text"
              name="currentLocation"
              value={formData.currentLocation}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
            >
              <option value="Pending">Pending</option>
              <option value="In Transit">In Transit</option>
              <option value="Delivered">Delivered</option>
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Timeline</label>
            {formData.timeline.map((entry, index) => (
              <div key={index} className="flex mb-2">
                <input
                  type="text"
                  placeholder="Location"
                  value={entry.location}
                  onChange={(e) => handleTimelineChange(index, 'location', e.target.value)}
                  className="p-2 border border-gray-300 rounded mr-2"
                />
                <input
                  type="text"
                  placeholder="Status"
                  value={entry.status}
                  onChange={(e) => handleTimelineChange(index, 'status', e.target.value)}
                  className="p-2 border border-gray-300 rounded mr-2"
                />
                <input
                  type="text"
                  placeholder="Timestamp"
                  value={entry.timestamp}
                  onChange={(e) => handleTimelineChange(index, 'timestamp', e.target.value)}
                  className="p-2 border border-gray-300 rounded"
                />
              </div>
            ))}
            <button
              type="button"
              onClick={addTimelineEntry}
              className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
            >
              Add Timeline Entry
            </button>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Date Shipped</label>
            <input
              type="date"
              name="dateShipped"
              value={formData.dateShipped}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Estimated Delivery Date</label>
            <input
              type="date"
              name="estimatedDelivery"
              value={formData.estimatedDelivery}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Update Shipment
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditShipment; 